import React, { useState } from "react"
import { useNavigate } from 'react-router-dom';
import axios from "axios"

import logo from "../logo.png"
import '../App.css';

function LoginComponent(props) {
  
  let navigate = useNavigate()
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")

  const updateUsername = (event) => {
    setUsername(event.target.value)
  }

  const updatePassword = (event) => {
    setPassword(event.target.value)
  }

  const handleSubmit = async (event) => {
    try {
      event.preventDefault()
      const payload = {name:username, password:password}
      const response = await axios.post("http://18.234.199.102:5000/login", payload, {headers:{
        'Access-Control-Allow-Origin' : 'http://frontend-container:3000',
        'Content-Type': 'application/json'
    }})
      if (response.data === "Incorrect Username. Please try again.") {
        window.alert(response.data)
        return " "
      } else if (response.data === "Incorrect Password. Please try again.") {
        window.alert(response.data)
        return " "
      } else {
        props.saveToken(response.data.access_token, response.data.username)
        navigate("/")
      }
    } catch (error) {
      console.log(error)
    }
  }


  return (
    <div className="login">
      <header className="login__header">
        <img src={logo} className="App-logo-still" alt="logo" />
        <form onSubmit={handleSubmit}>
          <h1 className="login__text">Login</h1>
          <input
          className="login__input"
          name="username"
          type="text"
          placeholder="Username"
          value={username}
          onChange={updateUsername}
          autoComplete="off"
          ></input>
          <div></div>
          <input
          className="login__input"
          name="password"
          type="password"
          placeholder="Password"
          value={password}
          onChange={updatePassword}
          autoComplete="off"
          ></input>
          <div></div>
          <button className="button">Submit</button>
        </form>        
      </header>
    </div>
  );
}

export default LoginComponent;